<template>

    <v-dialog v-model="dialog" max-width="800">
			<v-btn :flat="flat" slot="activator">
				<font-awesome-icon icon="list-alt" class="v-icon v-icon--left blue--text text--darken-4" />Запрос по Vin
			</v-btn>

      <v-card>
        <v-card-title class="justify-center">
          <span class="headline">Запрос по Vincode</span>
        </v-card-title>

        <v-card-text>
					<v-form ref="form" v-model="valid" lazy-validation>

						<v-container grid-list-md>
							<v-layout wrap>

								<v-flex xs12 md6>
									
									<v-text-field
										v-model="phone"
										:rules="phoneRules"
										label="Ваш телефон*"
										required
										placeholder="+7(777)777-77-77"
										mask="+7(###)###-##-##"
										return-masked-value
										clearable
										outline
										type="tel"
										validate-on-blur
									></v-text-field>
									
									<v-text-field
										v-model="vincode"
										:rules="[vincodeRules.required, vincodeRules.vincode]"
										label="Ваш VIN-код (Шасси №)"
										v-if="!isMobile()"
										:disabled="vincodeRules.disabled"
										placeholder="123ABC456DEF789HI"
										mask="NNNNNNNNNNNNNNNNN"
										return-masked-value
										clearable
										outline
										validate-on-blur
										@change="validateImage()"
										hint="Ваш vincode должен состоять из 17 символов"
									></v-text-field>

									<span v-if="!isMobile()">Или выберите снимок VIN-кода</span>

									<div :class="{filepond: true, 'error--text': filepondErrorMessage}">
									
										<file-pond
												name="Фото"
												ref="pond"

												:label-idle="labelIdle"
												labelInvalidField="Поле содержит недопустимые файлы"
												labelFileWaitingForSize="В ожидании размера файла"
												labelFileSizeNotAvailable="Размер файла недоступен"
												labelFileLoading="Загрузка"
												labelFileLoadError="Ошибка при загрузке"
												labelFileRemoveError="Ошибка при удалении"
												labelTapToCancel="нажмите, чтобы отменить"
												labelTapToRetry="нажмите, чтобы повторить попытку"
												labelTapToUndo="нажмите, чтобы отменить"
												labelButtonRemoveItem="Удалить"
												labelButtonAbortItemLoad="Прервать"
												labelButtonRetryItemLoad="Повторить попытку"

												accepted-file-types="image/jpeg, image/png"
												@addfile="handleFilePondAdd"
												@removefile="handleFilePondRemove"
											/>

											<div class="v-text-field__details" v-if="filepondErrorMessage">
												<div class="v-messages theme--light error--text">
													<div class="v-messages__wrapper">
														<div class="v-messages__message">{{filepondErrorMessage}}</div>
													</div>
												</div>
											</div>

									</div>
									
									<v-textarea
										label="Какие запчасти нужны*"
										v-model="parts"
										:rules="partsRules"
										clearable
										outline
									></v-textarea>
									
									<v-layout justify-center>

										<v-btn
											:disabled="loading || !valid"
											:loading="loading"
											@click="submit"
											class="white--text"
											color="black"
										>
											Отправить
										</v-btn>

									</v-layout>

								</v-flex>

								<v-flex md6 v-if="!isMobile()">
									<img v-lazy="require(`@/assets/img/vincode.png`)">
								</v-flex>

							</v-layout>
					</v-container>

				</v-form>
			</v-card-text>
		</v-card>

			<v-dialog
				v-model="response.responsed"
				hide-overlay
				persistent
				max-width="500"
			>
				<v-card
					v-if="response.type === 'error'"
					:color="response.type"
					dark
				>
					<v-card-title primary-title class="justify-center">
						<div>
							<div class="headline">Произошла ошибка.</div>
						</div>
					</v-card-title>

					<v-card-actions>
						<v-btn flat="flat" @click="clearAll">закрыть все</v-btn>
						<v-spacer></v-spacer>
						<v-btn flat="flat" @click="response.responsed = false">Попробовать снова</v-btn>
					</v-card-actions>

				</v-card>
				<v-card
					v-else-if="response.type === 'success'"
					:color="response.type"
					dark
				>
					<v-card-title primary-title class="justify-center">
						<div>
							<div class="headline text-xs-center">Спасибо за заявку! <br> С вами скоро свяжутся.</div>
						</div>
					</v-card-title>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat="flat" @click="clearAll">закрыть</v-btn>
					</v-card-actions>

				</v-card>
			</v-dialog>

  </v-dialog>
	
</template>

<script>
import axios from 'axios'
import detectingMobile from '@/mixins/detectingMobile'
// const detectingMobile = () => import('@/mixins/detectingMobile')

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Create component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	props: ['flat'],
  components: {
        FilePond
  },
  mixins: [
		detectingMobile
	],
	data() {
		return {
			dialog: false,
			error: '',
			errorAlert: false,
			success: '',
			successAlert: false,
			loading: false,
			response: {
				message: '',
				responsed: false,
				type: ''
			},

			projectName: 'Vw-audi.kz',
			formSubject: 'Vw-audi.kz Vincode',

      phone: '',
      phoneRules: [
        v => !!v || 'Пожалуйста, введите ваш номер телефона',
        v => (v && /^\+7(\(\d{3}\))\d{3}-\d{2}-\d{2}$/.test(v)) || 'Номер телефона не заполнен полностью'
			],

      vincode: '',
      // vincodeRules: [
      //   v => !!v || 'Пожалуйста, введите ваш VIN-код',
      //   v => (v && /^[0-9a-zA-Z]{17,17}$/.test(v)) || 'VIN-код не заполнен полностью'
			// ],

			vincodeRules: {
				required: value => !!value || 'Пожалуйста, введите ваш VIN-код.',
				vincode: value => /^[0-9a-zA-Z]{17,17}$/.test(value) || 'VIN-код не заполнен полностью.',
				disabled: false
			},

      parts: '',
      partsRules: [
        v => !!v || 'Пожалуйста, Напишите какие запчасти вам нужны'
			],

			images: null,
			filepondErrorMessage: '',

			valid: this.phoneRules && this.partsRules && (this.vincodeRules || this.images),
		}
	},
	created() {
		if (this.isMobile()) {
			this.vincodeRules.required = false
		}
	},
	computed: {
		labelIdle() {
			let label
			if (this.isMobile()) {
				label = "Нажмите сюда <br> чтобы сделать снимок VIN-кода <br> или выберите снимок"
			} else {
				label = "Нажмите сюда <br> чтобы выбрать снимок VIN-кода <br> или перетащите снимок сюда"
			}
			return label
		}
	},
	watch: {
		validateImage() {
			this.validateImage()
		}
	},
	methods: {
    handleFilePondAdd () {
			this.images = this.$refs.pond.getFile()

			this.vincodeRules.required = false
			this.vincodeRules.vincode = false
			this.vincodeRules.disabled = true

			this.validateImage()
    },
    handleFilePondRemove () {
			this.images = null

			if (!this.isMobile() || !this.images) {
				this.vincodeRules.required = value => !!value || 'Пожалуйста, введите ваш VIN-код.'
				this.vincodeRules.vincode = value => /^[0-9a-zA-Z]{17,17}$/.test(value) || 'VIN-код не заполнен полностью.'
				this.vincodeRules.disabled = false
			}
			this.validateImage()
		},
		validateImage() {
			// !isMobile === Desktop
			let bool

			if (this.isMobile() && !this.images) {
				this.filepondErrorMessage = 'Пожалуйста, выберите снимок'
				bool = false
			}

			if ((!this.isMobile() && this.vincode || this.images)) {
				this.filepondErrorMessage = ''
				bool = true
			}

			return bool
		},
		submit () {
			this.validateImage()
			if (this.$refs.form.validate() && this.validateImage()) {
				this.loading = true
				const self = this;

				const formData = new FormData();
				formData.append('project_name', this.projectName);
				formData.append('form_subject', this.formSubject);
				formData.append('Телефон', this.phone);

				if (this.vincode && this.vincodeRules.disabled === false)
				{
					formData.append('Vincode', this.vincode);
				}

				if (this.images) {
					let image = this.images.file
					formData.append(`Фото[]`, image);
					// for (let index = 0; index < this.images.length; index++) {
					// 	let image = this.images[index].file
					// 	console.log(image)
					// 	formData.append(`Фото[]`, image);
					// }
				}

				formData.append('Запчасти', this.parts);

				try {
					axios({
						method: "POST", 
						url:"/mail.php",
						data: formData,
					}).then((response)=>{
						self.loading = false
						self.response.responsed = true
						self.response.type = 'success'

						setTimeout(function() {
							self.clearAll()
						}, 4000);

					})
					.catch(function (error) {
						self.loading = false
						self.response.responsed = true
						self.response.type = 'error'
					})
				} catch(err) {
						this.loading = false
						this.response.responsed = false
						this.response.type = 'error'
				}
			}
		},
		clearAll() {
			this.dialog = false
			this.response.responsed = false
			this.$refs.pond.removeFiles()
			this.$refs.form.reset()
		}
	}
}
</script>

<style lang="stylus">
	.filepond
		color #000

	.v-text-field__details
		margin-bottom 8px

	.v-text-field__details
		padding 0 12px

	.filepond--panel-root
		background-color transparent
		border 2px solid currentColor
</style>
